import { create } from 'zustand'
import { getOpportunitiesNoticeText } from '@/modules/settings/services/settingsService'
import { supabase } from '@/lib/supabase'

type State = {
  loading: boolean
  acknowledged: boolean
  visible: boolean
  version: string | null
  html: string
  error: string | null
}

type Actions = {
  loadStatus: () => Promise<void>
  markAcknowledged: () => Promise<void>
  close: () => void
}

type Store = State & Actions

const initial: State = {
  loading: true,
  acknowledged: false,
  visible: false,
  version: null,
  html: '',
  error: null,
}

export const useOportunidadesNoticeStore = create<Store>((set, get) => ({
  ...initial,
  async loadStatus() {
    // Evita recarregar se já estiver carregado
    if (!get().loading && get().version) return

    set({ loading: true, error: null })
    try {
      const [statusRes, html] = await Promise.all([
        supabase.rpc('user_oportunidades_notice_status'),
        getOpportunitiesNoticeText(),
      ])

      const row = Array.isArray(statusRes.data) ? statusRes.data[0] : statusRes.data
      const acknowledged = !!row?.acknowledged
      const version = (row?.version as string) || null

      set({
        loading: false,
        acknowledged,
        visible: !acknowledged,
        version,
        html: html || '',
        error: null,
      })
    } catch (e: any) {
      // Em caso de erro, por segurança mantemos o modal visível
      set({
        loading: false,
        acknowledged: false,
        visible: true,
        version: null,
        html: '',
        error: e?.message || 'Falha ao carregar aviso de oportunidades',
      })
    }
  },
  async markAcknowledged() {
    const version = get().version || 'v1'
    set({ error: null })
    const { error } = await supabase.rpc('user_oportunidades_notice_ack', { p_version: version })
    if (error) {
      set({ error: error.message || 'Falha ao registrar aceite' })
      return
    }
    set({ acknowledged: true, visible: false })
  },
  close() {
    // Só fecha se já estiver marcado como acknowledged
    if (get().acknowledged) {
      set({ visible: false })
    }
  },
}))

